// ES6 syntax to extend jQuery with plugins
let $ = require('jquery');
// TODO: Comentada la validación de jQuery para que no moleste más. En un futuro eliminar del todo
// $ = require('jquery-validation');
//

//
require('../../../../node_modules/jquery-validation/dist/localization/messages_es.js');

$(document).ready(function() {
  const $header = $('.m-header');
  if ($header.length === 0){
    return;
  }
  const headerOffsetTop = $header[0].offsetTop;
  window.onscroll = function() { scrollHeader(); };

  //
  $header.find('.toggle-main-menu a, .close-main-menu a').on('click', (event) => {
    event.preventDefault();

    $header.toggleClass('show-menu');
  });

  $header.find('.overlay').on('click', (event) => {
    event.preventDefault();

    $header.removeClass('show-menu show-log-in');
  });

  //
  $header.find('.toggle-login a, .close-log-in a').on('click', (event) => {
    event.preventDefault();

    $header.toggleClass('show-log-in');
  });

  //
  $header.find('.main-nav > ul > li > a').on('click', function(event) {
    const $link = $(this);
    const $li = $link.closest('li');

    if ($li.find('.secondary-nav').length > 0) {
      event.preventDefault();

      if (!$li.hasClass('open-secondary-nav')) {
        $header.find('li.open-secondary-nav').removeClass('open-secondary-nav');
        $li.addClass('open-secondary-nav');
      }
      else {
        $header.find('li.open-secondary-nav').removeClass('open-secondary-nav');
      }

    }
  });

  $(".log-in-wrapper > a").on('click', function (event) {
    event.preventDefault();
    var $loginForm = $(".log-in-form");
    if ($loginForm.length === 1) {
      if ($loginForm.css("visibility") === "visible") {
        showLoginForm(false);
      }
      else {
        showLoginForm(true);
      }
    }

  });

  $('body').on('click', function (event) {
    var $evTarget = $(event.target);
    var $loginForm = $(".log-in-form");
    var $loginLink = $(".log-in-wrapper > a");
    if ($loginForm.length === 1 && $loginLink.length === 1) {
      if ($loginForm.css("visibility") === "visible") {
        if (($evTarget[0] != $loginForm[0] && $loginForm.find($evTarget).length === 0) && ($evTarget[0] != $loginLink[0])) {
          showLoginForm(false);
        }
      }
    }
  });

  function showLoginForm(show) {
    var $loginForm = $(".log-in-form");
    var $loginLink = $(".log-in-wrapper > a");
    $loginForm.toggleClass("log-in-form--visible", show);
    $loginLink.toggleClass("log-in-form-active", show);
  }

  function scrollHeader() {
    if (window.pageYOffset > headerOffsetTop) {
      $header.toggleClass("sticky-header", true);
    } else {
      $header.toggleClass("sticky-header", false);
    }
  }

  // Validate login form
  // $header.find('.log-in-form form').validate();
});



// WEBPACK FOOTER //
// ./app/ui/modules/header/index.js